/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskType } from './TaskType';
import {
    TaskTypeFromJSON,
    TaskTypeFromJSONTyped,
    TaskTypeToJSON,
    TaskTypeToJSONTyped,
} from './TaskType';
import type { TaskStatus } from './TaskStatus';
import {
    TaskStatusFromJSON,
    TaskStatusFromJSONTyped,
    TaskStatusToJSON,
    TaskStatusToJSONTyped,
} from './TaskStatus';

/**
 * 
 * @export
 * @interface RunTaskResponse
 */
export interface RunTaskResponse {
    /**
     * 
     * @type {number}
     * @memberof RunTaskResponse
     */
    taskExecutionId: number;
    /**
     * 
     * @type {TaskType}
     * @memberof RunTaskResponse
     */
    taskType: TaskType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RunTaskResponse
     */
    taskParams: { [key: string]: any; } | null;
    /**
     * 
     * @type {TaskStatus}
     * @memberof RunTaskResponse
     */
    taskStatus: TaskStatus;
    /**
     * 
     * @type {number}
     * @memberof RunTaskResponse
     */
    taskDurationMilliseconds: number;
}



/**
 * Check if a given object implements the RunTaskResponse interface.
 */
export function instanceOfRunTaskResponse(value: object): value is RunTaskResponse {
    if (!('taskExecutionId' in value) || value['taskExecutionId'] === undefined) return false;
    if (!('taskType' in value) || value['taskType'] === undefined) return false;
    if (!('taskParams' in value) || value['taskParams'] === undefined) return false;
    if (!('taskStatus' in value) || value['taskStatus'] === undefined) return false;
    if (!('taskDurationMilliseconds' in value) || value['taskDurationMilliseconds'] === undefined) return false;
    return true;
}

export function RunTaskResponseFromJSON(json: any): RunTaskResponse {
    return RunTaskResponseFromJSONTyped(json, false);
}

export function RunTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskExecutionId': json['task_execution_id'],
        'taskType': TaskTypeFromJSON(json['task_type']),
        'taskParams': json['task_params'],
        'taskStatus': TaskStatusFromJSON(json['task_status']),
        'taskDurationMilliseconds': json['task_duration_milliseconds'],
    };
}

export function RunTaskResponseToJSON(json: any): RunTaskResponse {
    return RunTaskResponseToJSONTyped(json, false);
}

export function RunTaskResponseToJSONTyped(value?: RunTaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_execution_id': value['taskExecutionId'],
        'task_type': TaskTypeToJSON(value['taskType']),
        'task_params': value['taskParams'],
        'task_status': TaskStatusToJSON(value['taskStatus']),
        'task_duration_milliseconds': value['taskDurationMilliseconds'],
    };
}

